/**
 * サンドボックスの実行先バッジ（管理アプリ）
 *
 * ## 監査で参照する記録である
 *
 * タスクの中身と同じだけ重要なのは、その作業がどこで処理されたかである。
 * クラウドで動いた作業は業務データが自社アカウント内の実行環境へ渡っている。
 *
 * ## 記録が無いときは出さない
 *
 * クラウド実行先の導入前に作られたタスクには記録が無い。そこへ「このパソコン」と
 * 補うと、確かめていないことを断定してしまう。**推測して埋めるより、空のほうが正しい。**
 */
import type { SandboxTarget } from '@kyumo/common';
import { Cloud, Monitor } from 'lucide-react';
import {
  CLOUD_SANDBOX_BADGE_COLOR,
  SANDBOX_TARGET_LABELS,
  SANDBOX_TARGET_TITLES,
} from './sandbox-target-label';

export interface SandboxTargetBadgeProps {
  target: SandboxTarget | undefined;
  className?: string;
}

export function SandboxTargetBadge({ target, className }: SandboxTargetBadgeProps) {
  if (!target) return null;

  const isCloud = target === 'cloud';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
        isCloud ? CLOUD_SANDBOX_BADGE_COLOR : 'bg-muted text-muted-foreground'
      } ${className ?? ''}`}
      data-testid="task-sandbox-target"
      data-sandbox-target={target}
      title={SANDBOX_TARGET_TITLES[target]}
    >
      {isCloud ? <Cloud className="w-3 h-3" /> : <Monitor className="w-3 h-3" />}
      {SANDBOX_TARGET_LABELS[target]}
    </span>
  );
}
